/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'

type Props = {
  color: string
  title: string
  description: string
  icon: string
}

const CardCustom1: FC<Props> = ({color, title, description, icon}) => {
  return (
    <div className='card h-100'>
      <div className={`card-body d-flex rounded-3 ${color} justify-content-center text-center flex-column p-8`}>
        <span className='text-gray-800 d-flex flex-column'>
          <div className='symbol symbol-75px mb-6'>
          <i className={`${icon} text-light fs-5x`}></i>
          </div>
          <div className='fs-5 fw-bold text-light mb-2'>{title}</div>
        </span>
        <div className='fs-6 fw-bold text-light mt-auto'>{description}</div>
      </div>
    </div>
  )
}

export {CardCustom1}
